// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE

import * as List from "bs-platform/lib/es6/list.js";
import * as $$Array from "bs-platform/lib/es6/array.js";
import * as Block from "bs-platform/lib/es6/block.js";
import * as Curry from "bs-platform/lib/es6/curry.js";
import * as React from "react";
import * as Button$Xuder from "./Button.bs.js";
import * as Events$Xuder from "../utils/Events.bs.js";
import * as Dropdown$Xuder from "./Dropdown.bs.js";
import * as XuderContext$Xuder from "../context/XuderContext.bs.js";

function OrForm(Props) {
  var onDrawImage = Props.onDrawImage;
  var state = XuderContext$Xuder.useState(/* () */0);
  var match = React.useReducer((function (param, v) {
          return v;
        }), undefined);
  var setContract1 = match[1];
  var contract1 = match[0];
  var match$1 = React.useReducer((function (param, v) {
          return v;
        }), undefined);
  var setContract2 = match$1[1];
  var contract2 = match$1[0];
  return React.createElement(React.Fragment, undefined, React.createElement("label", {
                  className: "compose-label"
                }, React.createElement("h5", undefined, "Contracts"), React.createElement(Dropdown$Xuder.make, {
                      values: $$Array.map((function (value) {
                              return /* tuple */[
                                      value[0],
                                      value[0]
                                    ];
                            }), $$Array.of_list(state[/* contracts */3])),
                      onChange: (function (e) {
                          return Curry._1(setContract1, List.find((function (c) {
                                              return c[0] === Events$Xuder.targetValue(e);
                                            }), state[/* contracts */3])[1]);
                        }),
                      name: "contract1"
                    }), React.createElement(Dropdown$Xuder.make, {
                      values: $$Array.map((function (value) {
                              return /* tuple */[
                                      value[0],
                                      value[0]
                                    ];
                            }), $$Array.of_list(state[/* contracts */3])),
                      onChange: (function (e) {
                          return Curry._1(setContract2, List.find((function (c) {
                                              return c[0] === Events$Xuder.targetValue(e);
                                            }), state[/* contracts */3])[1]);
                        }),
                      name: "contract2"
                    })), React.createElement(Button$Xuder.make, {
                  children: "Draw & Save",
                  onClick: (function (_e) {
                      if (contract1 !== undefined && contract2 !== undefined) {
                        return Curry._1(onDrawImage, /* AndContracts */Block.__(4, [/* contracts : :: */[
                                        contract1,
                                        /* :: */[
                                          contract2,
                                          /* [] */0
                                        ]
                                      ]]));
                      } else {
                        return /* () */0;
                      }
                    })
                }));
}

var make = OrForm;

export {
  make ,
  
}
/* react Not a pure module */
